import { render } from "./StackedBarChart.vue?vue&type=template&id=c843c6ae&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"

import "./StackedBarChart.vue?vue&type=style&index=0&id=c843c6ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c843c6ae"]])

export default __exports__